export default {
  landingSellerPerformancesTitle: {
    id: 'landing_seller_performances_title',
    defaultMessage: 'Performance',
  },
  landingSellerAge: {
    id: 'landing_seller_performances_age',
    defaultMessage: 'Lifespan on Back Market: {age}',
  },
  reviewLink: {
    id: 'landing_seller_performances_block1_reviews',
    defaultMessage: 'Backers Satisfaction: {rank, number}/{maxRating, number}',
  },
}
